import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
export function Offer() {
  return <Section data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <h2 className="font-display font-bold text-3xl md:text-5xl mb-8 uppercase tracking-tight" data-id="element-131">
          Tu momento de decisión
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-132">
          Recupera tu seguridad y el respeto en la recámara por una fracción de
          lo que cuesta una cena fuera o una consulta médica.
        </p>

        <div className="bg-brand-gray/10 border border-brand-blue/30 p-8 md:p-12 mb-12 relative overflow-hidden" data-id="element-133">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-blue/10 blur-3xl rounded-full" data-id="element-134"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-blue/10 blur-3xl rounded-full" data-id="element-135"></div>

          <img src="https://cdn.magicpatterns.com/uploads/fdUBYihwa9Bd217uqajg8X/heylloyd-image-1776793629058.png" alt="Protocolo 22" className="w-full max-w-md mx-auto h-auto object-contain mb-8 relative z-10" data-id="element-136" />

          <div id="offer-section" className="relative z-10" data-id="element-137">
            <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-138">
              Inversión Única
            </p>
            <div className="mb-2" data-id="element-139">
              <span className="font-display text-3xl md:text-4xl text-gray-500 line-through" data-id="element-140">
                $27 USD
              </span>
            </div>
            <div className="font-display font-bold text-6xl md:text-7xl text-white mb-2" data-id="element-141">
              $8.39 <span className="text-2xl text-brand-blue" data-id="element-142">USD</span>
            </div>
            <p className="text-brand-blue font-bold text-lg mb-8 uppercase tracking-wide" data-id="element-143">
              ¡Ahorra más del 68%!
            </p>

            <CTAButton onClick={() => window.open('https://omnifluo.com/cart/48300282183780:1', '_blank')} subtext="Descarga inmediata. Formato PDF compatible con móvil, tablet y PC." data-id="element-144" />
          </div>
        </div>
      </div>
    </Section>;
}